import type { MutationConfig } from "apps/visits/core/lib/react-query";
import type { AxiosError } from "axios";
import { useMutation } from "react-query";
import { VouchersDistributionsRepository } from "../vouchers-distribution.api";
import type { PatientAuthenticationErrorResponse } from "./patient-authentication.types";

const vouchersDistributionsRepository = new VouchersDistributionsRepository();

type UsePatientAuthenticationOptions = {
  config?: MutationConfig<
    typeof vouchersDistributionsRepository.patientAuthentication,
    AxiosError<PatientAuthenticationErrorResponse>
  >;
};

export const usePatientAuthentication = ({ config }: UsePatientAuthenticationOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: (data) => vouchersDistributionsRepository.patientAuthentication(data),
  });
};
